module.exports = __webpack_public_path__ + "static/media/autokar (5).f431d1d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/wynajem/autokar (5).jpg
// module id = 845
// module chunks = 0